const FEATURE_FLAG_URL_PARAM_PREFIX = 'ff.';
function getURLParamsFeatureFlagOverrides(search) {
    const urlParams = new URLSearchParams(search);
    const overrides = {};
    for (const [key, value] of urlParams.entries())if (key.startsWith(FEATURE_FLAG_URL_PARAM_PREFIX)) {
        const flagName = key.slice(3);
        try {
            overrides[flagName] = JSON.parse(value);
        } catch (_e) {
            overrides[flagName] = value;
        }
    }
    return overrides;
}
function getFeatureFlagOverridesFromEnv() {
    try {
        if ('development' !== process.env.NODE_ENV) return {};
        if ('true' === process.env.SKIP_FEATURE_FLAGS_OVERRIDES) return {};
        const flagStr = process.env.FEATURE_FLAG_OVERRIDES;
        return void 0 === flagStr ? {} : flagStr;
    } catch (e) {
        console.error('Error parsing feature flag override values', e);
        return {};
    }
}
export { FEATURE_FLAG_URL_PARAM_PREFIX, getFeatureFlagOverridesFromEnv, getURLParamsFeatureFlagOverrides };

//# sourceMappingURL=feature-flag-overrides.js.map